import React from 'react'
import './About.css'
import { FaChevronRight } from 'react-icons/fa6'
import abthm from '../../../../assets/img/abt_hm.webp'
import CountUpOnScroll from './ScrollCounter'

function About() {
  
  return (
    <section className='hmeabt-sec'>
        <div className='container'>
        <div className='head-ing' data-content='About'>About</div> 
        <div className='hmeabt-img'>
            <img src={abthm} alt='About 360 Bytes' width={800} height={600} loading="lazy"/>
            <div className='hmeabt-count'>
              <ul id="countup">
                <li><h4> <CountUpOnScroll end={10} /></h4><p>Years Experience</p></li>  
                <li><h4> <CountUpOnScroll end={80} /> +</h4><p>Happy Customers</p></li> 
                <li><h4> <CountUpOnScroll end={100} /> +</h4><p>Projects</p></li> 
              </ul>  
            </div>
        </div>
        <div className='hmeabt-txt'>
            <div className='mn-head'> 
                <h5>Wide range of IT Solutions & Services</h5>
                <h3>360 Bytes - IT Solutions</h3>
            </div>
            <p>Over the years we have established ourselves as the leading service provider for Mobile Application Development, Website Design & Development, Web and Graphic Design, E-Commerce Development, Software as a Solution (Saas - cloud solution), Digital Transformation and Product Engineering company based out of Doha, Qatar. </p>
            <button className='btn-main' onClick={() => window.location.href = '/about'}><span>About Company</span> <FaChevronRight/></button>
        </div>
        </div>
    </section>
  )
}

export default About
